import ko from 'knockout';
import $ from 'jquery';

import _ from 'lodash';
import window from 'window';
import onBeforeUnloadHandler from 'window-onbeforeunload-handler';

const NAME = 'data-screen-adapter'; //attribute

/* test  v.0.0.0.3*/

let hasSubscription = false;

const listeners = [];

const notifyAboutChanges = () => {
	listeners.forEach(callback => callback());
};

ko.bindingHandlers.screenAdapter = {
	init: (element, valueAccessor) => {
		const {diff, isRendered} = valueAccessor();

		if (!hasSubscription) {
			subscribeOnResize();
			hasSubscription = true;
		}

		listeners.push(() => adaptContainer(element, diff));
		//first render depends on flag (isRendered)
		doFirstTask({isRendered, diff, element});
	},
};

function doFirstTask ({isRendered, diff, element}) {
	ko.computed(() => {
		const done = ko.unwrap(isRendered);

		if (done) {
			adaptContainer(element, diff);
		}

	}, null, {disposeWhenNodeIsRemoved: element});
}

function subscribeOnResize () {
	const callback = _.throttle(notifyAboutChanges, 200);

	window.addEventListener('resize', callback);
	onBeforeUnloadHandler.push(() => window.removeEventListener('resize', callback));
}

function adaptContainer (element, diff) {
	const containerWidth = $(element).width(); //depending on resolution
	const changeableWidth = $(element).find(`[${NAME}-mutable]`).width();

	if (changeableWidth <= 0 || containerWidth <= 0) {
		return false;
	}

	if (containerWidth - changeableWidth < diff) {
		$(element).find(`[${NAME}-target]`)
			.each((i, target) => {
				const $target = $(target);
				const [add, remove] = $target.data('screenAdapterTarget').split('!');

				$target.addClass(add);
				$target.removeClass(remove);
			});
	}
}
